import { jsx as n, jsxs as a } from "react/jsx-runtime";
const t = (e) => /* @__PURE__ */ n("div", { className: "text-sm text-muted-foreground", children: e.selecting === "end" ? /* @__PURE__ */ a("span", { children: [
  "Select end date",
  " ",
  /* @__PURE__ */ a("span", { className: "text-xs", children: [
    "(min ",
    e.minPeriodDays,
    ", max ",
    e.maxPeriodDays,
    " days)"
  ] })
] }) : /* @__PURE__ */ a("span", { children: [
  /* @__PURE__ */ n("strong", { className: "text-foreground", children: e.start }),
  /* @__PURE__ */ n("span", { className: "mx-2", children: "→" }),
  /* @__PURE__ */ n("strong", { className: "text-foreground", children: e.end }),
  e.showDaysCount && /* @__PURE__ */ a("span", { className: "ml-2 text-foreground font-medium", children: [
    "(",
    e.periodDays,
    " days)"
  ] })
] }) });
export {
  t as SelectionSummary
};
